
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryIcons from './components/CategoryIcons';
import LifestyleGallery from './components/LifestyleGallery';
import ProductSection from './components/ProductSection';
import BeforeAfter from './components/BeforeAfter';
import MensLifestyle from './components/MensLifestyle';
import Reviews from './components/Reviews';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <CategoryIcons />
      <LifestyleGallery />
      <ProductSection title="Daily Vitamins & Minerals" category="vitamins" />
      <ProductSection title="Sports & Fitness Supplements" category="sports" />
      <BeforeAfter />
      <ProductSection title="Immune Support" category="immunity" />
      <ProductSection title="Brain & Cognitive Health" category="brain" />
      <MensLifestyle />
      <ProductSection title="Weight Management" category="weight" />
      <ProductSection title="Heart & Cardiovascular" category="heart" />
      <ProductSection title="Digestive Health" category="digestive" />
      <Reviews />
      <Newsletter />
      <Footer />
    </div>
  );
}
